import React, {useCallback} from "react";
import styled from "@emotion/styled";

import Grid from "../components/assignedstops/grid/Grid";
import {useAssignmentDispatch} from "../providers/AssignmentProdiver";
import {TManifestDetailsDrawerOpen} from "./UnassignedJobsView";
import {useDispatchRulesDataContext} from "../providers/DispatchRulesDataProvider";
import {LoadingSpinner} from "../components/common/LoadingSpinner";
import {Drawer, Position} from "@blueprintjs/core";
import ManifestDetailsChangeEventProvider from "../components/manifest/details/ManifestDetailsChangeEventProvider";
import {MapVisibilityProvider} from "../components/map/MapVisibilityContext";
import ManifestDetailsContainer from "../components/manifest/details/ManifestDetailsContainer";
import ListActionBar from "../components/common/ListActionBar";
import {usePreferenceContext} from "../providers/PreferenceProvider";
import {useDispatchDataContext} from "../providers/DispatchDataProvider";
import {useDispatchStationContext} from "../providers/DispatchStationProvider";
import {useAssignmentViewState} from "../providers/AssignmentViewProvider";
import {useManifestDetailsDispatch, useManifestDetailsState} from "../providers/ManifestDetailsProvider";

const AssignedStopsView = () => {
  const assignmentViewState = useAssignmentViewState();
  const assignmentStateDispatch = useAssignmentDispatch();
  const manifestDetailsState = useManifestDetailsState();
  const manifestDetailsDispatch = useManifestDetailsDispatch();

  const {loading} = useDispatchRulesDataContext();
  const {isUserPreferencesLoaded} = usePreferenceContext();
  const {isDispatchDataLoaded} = useDispatchDataContext();
  const {isDispatchStationLoaded} = useDispatchStationContext();

  const handleManifestDetailsDrawerOpen: TManifestDetailsDrawerOpen = useCallback(
    (manifestDriverId, driverId) => {
      assignmentStateDispatch({type: "ClearSelections"});
      manifestDetailsDispatch({
        type: "SET_MANIFEST_DETAILS",
        payload: {
          manifestDriverId: manifestDriverId,
          driverId: driverId
        }
      });
    },
    [assignmentStateDispatch, manifestDetailsDispatch]
  );

  const handleManifestDetailsDrawerClose = useCallback(() => {
    assignmentStateDispatch({type: "ClearSelections"});
    manifestDetailsDispatch({
      type: "CLEAR_MANIFEST_DETAILS"
    });
  }, [assignmentStateDispatch, manifestDetailsDispatch]);

  return (
    <LoadingSpinner loading={loading || !isUserPreferencesLoaded || !isDispatchDataLoaded || !isDispatchStationLoaded}>
      <Container data-testid="assigned-stops-container">
        <Body>
          <Grid
            assignmentViewState={assignmentViewState}
            onManifestDetailsDrawerOpen={handleManifestDetailsDrawerOpen}
          />
        </Body>
        <Drawer
          className="drawer_container"
          isOpen={manifestDetailsState.manifestDriverId !== undefined}
          onClose={handleManifestDetailsDrawerClose}
          canEscapeKeyClose
          enforceFocus={false}
          canOutsideClickClose={false}
          hasBackdrop={false}
          size="100%"
          position={Position.LEFT}
          portalClassName="manifest-details-portal"
        >
          {manifestDetailsState.manifestDriverId && (
            <ManifestDetailsChangeEventProvider manifestDriverId={manifestDetailsState.manifestDriverId}>
              <MapVisibilityProvider>
                <ManifestDetailsContainer
                  manifestDriverId={manifestDetailsState.manifestDriverId}
                  onClose={handleManifestDetailsDrawerClose}
                />
                <ListActionBar />
              </MapVisibilityProvider>
            </ManifestDetailsChangeEventProvider>
          )}
        </Drawer>
      </Container>
    </LoadingSpinner>
  );
};

export default AssignedStopsView;

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Body = styled.div`
  display: flex;
  flex-grow: 1;
`;
